import { render, staticRenderFns } from "./AdminPaymentReceiptFilters.vue?vue&type=template&id=5335d6a0"
import script from "./AdminPaymentReceiptFilters.vue?vue&type=script&lang=js"
export * from "./AdminPaymentReceiptFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports